import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectionService } from '@app/core/services/redirection.service';

@Component({
  selector: 'app-invalid-configuration',
  templateUrl: './invalid-configuration.component.html',
  styleUrls: ['./invalid-configuration.component.scss']
})
export class InvalidConfigurationComponent implements OnInit {

  constructor(private redirectService: RedirectionService) { }

  ngOnInit(): void {
  }

  retry(): void {
    this.redirectService.redirectToUploader();
  }
}
